import { render, staticRenderFns } from "./TableRiskAppraisalFIRA.vue?vue&type=template&id=e647f2b2&scoped=true&"
import script from "./TableRiskAppraisalFIRA.vue?vue&type=script&lang=js&"
export * from "./TableRiskAppraisalFIRA.vue?vue&type=script&lang=js&"
import style0 from "./TableRiskAppraisalFIRA.vue?vue&type=style&index=0&id=e647f2b2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e647f2b2",
  null
  
)

export default component.exports